<template>
  <ResponsiveLayout
    sticky-actions
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
    :progress="progress"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>

    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <p
          class="kds-typography-display-small kds-typography-center"
          v-html="$t('b2b_self_test_get_started')"
        />

        <p
          class="kds-typography-paragraph-large kds-typography-center"
          v-html="$t('b2b_self_test_get_started_content')"
        />
      </div>

      <div class="welcome-theme-figure">
        <LottieAnimationContainer :json-config-path="jsonConfigPath" />
      </div>
    </div>

    <template #actions>
      <BaseButton
        :text="$t('b2b_get_started_btn_text')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import LottieAnimationContainer from '@shared/components/LottieAnimationContainer.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import env from '@shared/env.js'

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const jsonConfigPath = `${env.VITE_PUBLIC_PATH}static/lottie-self-test-welcome-media.json`
</script>

<style lang="scss">
.welcome-theme-figure {
  margin: 0 auto;
  width: 66%;
}
</style>
